import React, { useEffect, useState } from "react";
import "../../Styles/Slider.css"; // Import your CSS file for styling
import { FiCheckCircle, FiUser, FiStar } from "react-icons/fi";
import appstore from "../../Assets/app-store.png";
import googleplay from "../../Assets/google-play.png";
import TechAppDownload from "../../Constants/TechAppDownload";
import telechargerActive from "../../Assets/telecharger-icon.png";
import telecharger from "../../Assets/telecharger-icon-incactive.png";
import phoneActive from "../../Assets/phone-icon.png";
import phone from "../../Assets/phone-icon-inactive.png";
import diamondActive from "../../Assets/diamond-icon.png";
import diamond from "../../Assets/diamond-icon-inactive.png";
import phoneMoc from "../../Assets/Phone-moc.png";
import DownloadButtons from "./DownloadButtons";

const buttonContent = [
  {
    title: "Téléchargez l'application !",
    text: "Téléchargez LeBonTechnicien pour une Maintenance simplifiée de vos équipements d'énergie renouvelable.",
    icon: "test",
    image: "https://i.ibb.co/ZLVQY1f/slide-profiter-application-user-1.png",
  },
  {
    title: "Créez votre profil !",
    text: "Créez votre profil, débloquez toutes les fonctionnalités de l'application.",
    icon: "test",
    image: "https://i.ibb.co/3yZ3gLf/slide-profiter-application-tech-1.png",
  },
  {
    title: "Profitez de l'application !",
    text: "Profitez pleinement de toutes les fonctionnalités de l'application maintenant.",
    icon: "test",
    image: "https://i.ibb.co/TKmPps1/slide-telechargement-tech-app.png",
  },
];

const TechSlider = () => {
  const [currentImage, setCurrentImage] = useState(0);

  /*const handleImageChange = (direction) => {
    let newIndex = currentImage;
    if (direction === "prev") {
      newIndex = (currentImage - 1 + images.length) % images.length;
    } else if (direction === "next") {
      newIndex = (currentImage + 1) % images.length;
    }
    setCurrentImage(newIndex);
  };*/

  useEffect(() => {
    // Use setInterval to change the image every 5 seconds (5000 milliseconds)
    const intervalId = setInterval(() => {
      // Calculate the next image index
      const nextImage = (currentImage + 1) % TechAppDownload.length;
      setCurrentImage(nextImage);
    }, 3000); // 5000 milliseconds = 5 seconds

    // Clear the interval when the component unmounts to prevent memory leaks
    return () => clearInterval(intervalId);
  }, [currentImage]);

  return (
    <div className="big-container container">
      <div className="button-container">
        <div className="buttons-div">
          {TechAppDownload.map((_, index) => (
            <div style={{ display: "flex", gap: "15px" }}>
              <div
                className={`circle-icon ${
                  currentImage === index ? "active" : ""
                }`}
                key={index}
                onClick={() => setCurrentImage(index)}
              >
                {index === 0 && (
                  <img
                    src={
                      currentImage === index ? telechargerActive : telecharger
                    }
                    style={{ width: "30px", height: "30px" }}
                    alt="Telecharger"
                  />
                )}
                {index === 1 && (
                  <img
                    src={currentImage === index ? phoneActive : phone}
                    style={{ width: "30px", height: "30px" }}
                    alt="Phone"
                  />
                )}
                {index === 2 && (
                  <img
                    src={currentImage === index ? diamondActive : diamond}
                    style={{ width: "30px", height: "30px" }}
                    alt="Diamond"
                  />
                )}
              </div>
              <div className="info-text-div">
                <div className="info-text">
                  <h2>{TechAppDownload[index].title}</h2>
                  <p>{TechAppDownload[index].text}</p>
                </div>
              </div>
            </div>
          ))}
          <div className="button-container" style={{ marginBottom: "20px" }}>
            <DownloadButtons
              appStoreLink="https://apps.apple.com/fr/app/lebontech-pro/id6450013173"
              googlePlayLink="https://play.google.com/store/apps/details?id=com.devinov.LeBonTechnicienPro"
            />
          </div>
        </div>
      </div>
      <div className="how-app-work-slider-wrapper">
        <div
          className="carousel-container"
          style={{
            backgroundImage: `url(${phoneMoc})`,
          }}
        />
        <div className="image-container-slider">
          {TechAppDownload.map((content, index) => (
            <div
              key={index}
              className={`carousel-image ${
                index === currentImage ? "active" : ""
              }`}
              style={{
                backgroundImage: `url(${content.image})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechSlider;
